import { render, staticRenderFns } from "./extra-fodyn-builder.vue?vue&type=template&id=4425d575&lang=pug&"
import script from "./extra-fodyn-builder.vue?vue&type=script&lang=js&"
export * from "./extra-fodyn-builder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports